// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file tasks/tasks.proto (package lvdr.v2.tasks, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tasks/tasks.proto.
 */
export const file_tasks_tasks: GenFile = /*@__PURE__*/
  fileDesc("ChF0YXNrcy90YXNrcy5wcm90bxINbHZkci52Mi50YXNrcyIzCghUYXNrTGluaxIMCgRraW5kGAEgASgJEgoKAmlkGAIgASgJEg0KBWxhYmVsGAMgASgJIo0FCgRUYXNrEg8KB3Rhc2tfaWQYASABKAkSDQoFdGl0bGUYAiABKAkSDQoFbm90ZXMYAyABKAkSKQoGc3RhdHVzGAQgASgOMhkubHZkci52Mi50YXNrcy5UYXNrU3RhdHVzEi0KCHByaW9yaXR5GAUgASgOMhsubHZkci52Mi50YXNrcy5UYXNrUHJpb3JpdHkSJwoDZHVlGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIMCgR0YWdzGAcgAygJEikKBnNvdXJjZRgIIAEoDjIZLmx2ZHIudjIudGFza3MuVGFza1NvdXJjZRImCgVsaW5rcxgJIAMoCzIXLmx2ZHIudjIudGFza3MuVGFza0xpbmsSLgoKY3JlYXRlZF9hdBgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgLIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFAoMZXN0aW1hdGVfbWluGAwgASgNEjMKD3NjaGVkdWxlZF9zdGFydBgNIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMQoNc2NoZWR1bGVkX2VuZBgOIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEQoJc2VyaWVzX2lkGA8gASgJEhIKCm9jY3VycmVuY2UYECABKA0SOgoPYXR0ZW50aW9uX2xldmVsGBEgASgOMiEubHZkci52Mi50YXNrcy5UYXNrQXR0ZW50aW9uTGV2ZWwSMQoNc25vb3plZF91bnRpbBgSIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAimAIKClJlY3VycmVuY2USLwoGYW5jaG9yGAEgASgOMh8ubHZkci52Mi50YXNrcy5SZWN1cnJlbmNlQW5jaG9yEisKBGZyZXEYAiABKA4yHS5sdmRyLnYyLnRhc2tzLlJlY3VycmVuY2VGcmVxEhAKCGludGVydmFsGAMgASgNEhAKCHdlZWtkYXlzGAQgAygNEhEKCW1vbnRoX2RheRgFIAEoDRIQCgh0aW1lem9uZRgGIAEoCRIpCgVzdGFydBgHIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKQoFdW50aWwYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg0KBWNvdW50GAkgASgNIrsBCgxUYXNrVGVtcGxhdGUSDQoFdGl0bGUYASABKAkSDQoFbm90ZXMYAiABKAkSLQoIcHJpb3JpdHkYAyABKA4yGy5sdmRyLnYyLnRhc2tzLlRhc2tQcmlvcml0eRIMCgR0YWdzGAQgAygJEhQKDGVzdGltYXRlX21pbhgFIAEoDRI6Cg9hdHRlbnRpb25fbGV2ZWwYBiABKA4yIS5sdmRyLnYyLnRhc2tzLlRhc2tBdHRlbnRpb25MZXZlbCL6AgoKVGFza1NlcmllcxIRCglzZXJpZXNfaWQYASABKAkSJwoEcnVsZRgCIAEoCzIZLmx2ZHIudjIudGFza3MuUmVjdXJyZW5jZRItCgh0ZW1wbGF0ZRgDIAEoCzIbLmx2ZHIudjIudGFza3MuVGFza1RlbXBsYXRlEiwKCG5leHRfZHVlGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgpsYXN0X3NwYXduGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIPCgdzcGF3bmVkGAYgASgNEg4KBm1pc3NlZBgHIAEoDRIOCgZwYXVzZWQYCCABKAgSEgoKbGFzdF9lcnJvchgJIAEoCRIuCgpjcmVhdGVkX2F0GAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKDAQoTQ3JlYXRlU2VyaWVzUmVxdWVzdBItCgh0ZW1wbGF0ZRgBIAEoCzIbLmx2ZHIudjIudGFza3MuVGFza1RlbXBsYXRlEicKBHJ1bGUYAiABKAsyGS5sdmRyLnYyLnRhc2tzLlJlY3VycmVuY2USFAoMd29ya3NwYWNlX2lkGAMgASgJIpYBChNVcGRhdGVTZXJpZXNSZXF1ZXN0EhEKCXNlcmllc19pZBgBIAEoCRItCgh0ZW1wbGF0ZRgCIAEoCzIbLmx2ZHIudjIudGFza3MuVGFza1RlbXBsYXRlEicKBHJ1bGUYAyABKAsyGS5sdmRyLnYyLnRhc2tzLlJlY3VycmVuY2USFAoMd29ya3NwYWNlX2lkGAQgASgJIikKEUxpc3RTZXJpZXNSZXF1ZXN0EhQKDHdvcmtzcGFjZV9pZBgBIAEoCSJAChVTa2lwT2NjdXJyZW5jZVJlcXVlc3QSEQoJc2VyaWVzX2lkGAEgASgJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCSJNChJQYXVzZVNlcmllc1JlcXVlc3QSEQoJc2VyaWVzX2lkGAEgASgJEg4KBnBhdXNlZBgCIAEoCBIUCgx3b3Jrc3BhY2VfaWQYAyABKAkiPgoTRGVsZXRlU2VyaWVzUmVxdWVzdBIRCglzZXJpZXNfaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJIjsKDlNlcmllc1Jlc3BvbnNlEikKBnNlcmllcxgBIAEoCzIZLmx2ZHIudjIudGFza3MuVGFza1NlcmllcyI/ChJTZXJpZXNMaXN0UmVzcG9uc2USKQoGc2VyaWVzGAEgAygLMhkubHZkci52Mi50YXNrcy5UYXNrU2VyaWVzIikKFERlbGV0ZVNlcmllc1Jlc3BvbnNlEhEKCXNlcmllc19pZBgBIAEoCSKcAgoRQ3JlYXRlVGFza1JlcXVlc3QSDQoFdGl0bGUYASABKAkSDQoFbm90ZXMYAiABKAkSLQoIcHJpb3JpdHkYAyABKA4yGy5sdmRyLnYyLnRhc2tzLlRhc2tQcmlvcml0eRInCgNkdWUYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEgwKBHRhZ3MYBSADKAkSFAoMd29ya3NwYWNlX2lkGAYgASgJEjoKD2F0dGVudGlvbl9sZXZlbBgHIAEoDjIhLmx2ZHIudjIudGFza3MuVGFza0F0dGVudGlvbkxldmVsEjEKDXNub296ZWRfdW50aWwYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIjcKDkdldFRhc2tSZXF1ZXN0Eg8KB3Rhc2tfaWQYASABKAkSFAoMd29ya3NwYWNlX2lkGAIgASgJIoIEChFVcGRhdGVUYXNrUmVxdWVzdBIPCgd0YXNrX2lkGAEgASgJEg0KBXRpdGxlGAIgASgJEg0KBW5vdGVzGAMgASgJEikKBnN0YXR1cxgEIAEoDjIZLmx2ZHIudjIudGFza3MuVGFza1N0YXR1cxItCghwcmlvcml0eRgFIAEoDjIbLmx2ZHIudjIudGFza3MuVGFza1ByaW9yaXR5EicKA2R1ZRgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASDAoEdGFncxgHIAMoCRIRCgljbGVhcl9kdWUYCCABKAgSFAoMZXN0aW1hdGVfbWluGAkgASgNEhYKDmNsZWFyX2VzdGltYXRlGAogASgIEhMKC2NsZWFyX25vdGVzGAsgASgIEhYKDmNsZWFyX3ByaW9yaXR5GAwgASgIEhQKDHdvcmtzcGFjZV9pZBgNIAEoCRI6Cg9hdHRlbnRpb25fbGV2ZWwYDiABKA4yIS5sdmRyLnYyLnRhc2tzLlRhc2tBdHRlbnRpb25MZXZlbBIdChVjbGVhcl9hdHRlbnRpb25fbGV2ZWwYDyABKAgSMQoNc25vb3plZF91bnRpbBgQIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGwoTY2xlYXJfc25vb3plZF91bnRpbBgRIAEoCCI6ChFEZWxldGVUYXNrUmVxdWVzdBIPCgd0YXNrX2lkGAEgASgJEhQKDHdvcmtzcGFjZV9pZBgCIAEoCSJTChBMaXN0VGFza3NSZXF1ZXN0EikKBnN0YXR1cxgBIAEoDjIZLmx2ZHIudjIudGFza3MuVGFza1N0YXR1cxIUCgx3b3Jrc3BhY2VfaWQYAiABKAkiMQoMVGFza1Jlc3BvbnNlEiEKBHRhc2sYASABKAsyEy5sdmRyLnYyLnRhc2tzLlRhc2siNgoQVGFza0xpc3RSZXNwb25zZRIiCgV0YXNrcxgBIAMoCzITLmx2ZHIudjIudGFza3MuVGFzayIlChJEZWxldGVUYXNrUmVzcG9uc2USDwoHdGFza19pZBgBIAEoCSJHChFBZGRUYXNrVGFnUmVxdWVzdBIPCgd0YXNrX2lkGAEgASgJEgsKA3RhZxgCIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAyABKAkiSgoUUmVtb3ZlVGFza1RhZ1JlcXVlc3QSDwoHdGFza19pZBgBIAEoCRILCgN0YWcYAiABKAkSFAoMd29ya3NwYWNlX2lkGAMgASgJIl8KD0xpbmtUYXNrUmVxdWVzdBIPCgd0YXNrX2lkGAEgASgJEiUKBGxpbmsYAiABKAsyFy5sdmRyLnYyLnRhc2tzLlRhc2tMaW5rEhQKDHdvcmtzcGFjZV9pZBgDIAEoCSJUChFVbmxpbmtUYXNrUmVxdWVzdBIPCgd0YXNrX2lkGAEgASgJEgwKBGtpbmQYAiABKAkSCgoCaWQYAyABKAkSFAoMd29ya3NwYWNlX2lkGAQgASgJIkgKFkxpc3RUYXNrc0J5TGlua1JlcXVlc3QSDAoEa2luZBgBIAEoCRIKCgJpZBgCIAEoCRIUCgx3b3Jrc3BhY2VfaWQYAyABKAkigwEKB1Rhc2tSZWYSDwoHdGFza19pZBgBIAEoCRINCgV0aXRsZRgCIAEoCRIpCgZzdGF0dXMYAyABKA4yGS5sdmRyLnYyLnRhc2tzLlRhc2tTdGF0dXMSLQoIcHJpb3JpdHkYBCABKA4yGy5sdmRyLnYyLnRhc2tzLlRhc2tQcmlvcml0eSJAChdMaXN0VGFza3NCeUxpbmtSZXNwb25zZRIlCgV0YXNrcxgBIAMoCzIWLmx2ZHIudjIudGFza3MuVGFza1JlZiqFAQoMVGFza1ByaW9yaXR5Eh0KGVRBU0tfUFJJT1JJVFlfVU5TUEVDSUZJRUQQABIUChBUQVNLX1BSSU9SSVRZX1AxEAESFAoQVEFTS19QUklPUklUWV9QMhACEhQKEFRBU0tfUFJJT1JJVFlfUDMQAxIUChBUQVNLX1BSSU9SSVRZX1A0EAQqiwEKClRhc2tTdGF0dXMSGwoXVEFTS19TVEFUVVNfVU5TUEVDSUZJRUQQABIUChBUQVNLX1NUQVRVU19PUEVOEAESGwoXVEFTS19TVEFUVVNfSU5fUFJPR1JFU1MQAhIUChBUQVNLX1NUQVRVU19ET05FEAMSFwoTVEFTS19TVEFUVVNfRFJPUFBFRBAEKokBCgpUYXNrU291cmNlEhsKF1RBU0tfU09VUkNFX1VOU1BFQ0lGSUVEEAASFgoSVEFTS19TT1VSQ0VfTUFOVUFMEAESFQoRVEFTS19TT1VSQ0VfRU1BSUwQAhIVChFUQVNLX1NPVVJDRV9TV0VFUBADEhgKFFRBU0tfU09VUkNFX1JFU0VBUkNIEAQqmQEKElRhc2tBdHRlbnRpb25MZXZlbBIkCiBUQVNLX0FUVEVOVElPTl9MRVZFTF9VTlNQRUNJRklFRBAAEh0KGVRBU0tfQVRURU5USU9OX0xFVkVMX0RFRVAQARIeChpUQVNLX0FUVEVOVElPTl9MRVZFTF9MSUdIVBACEh4KGlRBU0tfQVRURU5USU9OX0xFVkVMX1FVSUNLEAMqdAoQUmVjdXJyZW5jZUFuY2hvchIhCh1SRUNVUlJFTkNFX0FOQ0hPUl9VTlNQRUNJRklFRBAAEhsKF1JFQ1VSUkVOQ0VfQU5DSE9SX0ZJWEVEEAESIAocUkVDVVJSRU5DRV9BTkNIT1JfQ09NUExFVElPThACKqEBCg5SZWN1cnJlbmNlRnJlcRIfChtSRUNVUlJFTkNFX0ZSRVFfVU5TUEVDSUZJRUQQABIZChVSRUNVUlJFTkNFX0ZSRVFfREFJTFkQARIaChZSRUNVUlJFTkNFX0ZSRVFfV0VFS0xZEAISGwoXUkVDVVJSRU5DRV9GUkVRX01PTlRITFkQAxIaChZSRUNVUlJFTkNFX0ZSRVFfWUVBUkxZEARCJlokZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL3Rhc2tzYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * Back-reference from a task to another LVDR entity (a research project, a
 * note, a knowledge node, or a sweep-produced artifact).
 *
 * @generated from message lvdr.v2.tasks.TaskLink
 */
export type TaskLink = Message<"lvdr.v2.tasks.TaskLink"> & {
  /**
   * "research" | "note" | "knowledge" | "artifact" | "interaction" | "interaction_removed"
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;
};

/**
 * Describes the message lvdr.v2.tasks.TaskLink.
 * Use `create(TaskLinkSchema)` to create a new message.
 */
export const TaskLinkSchema: GenMessage<TaskLink> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 0);

/**
 * @generated from message lvdr.v2.tasks.Task
 */
export type Task = Message<"lvdr.v2.tasks.Task"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskStatus status = 4;
   */
  status: TaskStatus;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 5;
   */
  priority: TaskPriority;

  /**
   * optional; unset = no due date
   *
   * @generated from field: google.protobuf.Timestamp due = 6;
   */
  due?: Timestamp | undefined;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: lvdr.v2.tasks.TaskSource source = 8;
   */
  source: TaskSource;

  /**
   * @generated from field: repeated lvdr.v2.tasks.TaskLink links = 9;
   */
  links: TaskLink[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * COS-03 time-block. estimate_min is the expected duration (0 = unset).
   * scheduled_start/end are the planner's assigned block for the current day
   * (unset = not scheduled) — written only by the time-block planner, never the
   * update path.
   *
   * @generated from field: uint32 estimate_min = 12;
   */
  estimateMin: number;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_start = 13;
   */
  scheduledStart?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_end = 14;
   */
  scheduledEnd?: Timestamp | undefined;

  /**
   * TASKS-05 recurrence. Empty series_id = a hand-authored task, which is the
   * overwhelming majority. When set, this task was materialised from the series
   * of that id and `occurrence` is its SPAWN INDEX within that series — not the
   * count of elapsed periods, which diverges after any catch-up.
   *
   * @generated from field: string series_id = 15;
   */
  seriesId: string;

  /**
   * @generated from field: uint32 occurrence = 16;
   */
  occurrence: number;

  /**
   * COS-23: how much focus the task needs; UNSPECIFIED = not set.
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel attention_level = 17;
   */
  attentionLevel: TaskAttentionLevel;

  /**
   * unset = not snoozed; a past instant = not snoozed
   *
   * @generated from field: google.protobuf.Timestamp snoozed_until = 18;
   */
  snoozedUntil?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.Task.
 * Use `create(TaskSchema)` to create a new message.
 */
export const TaskSchema: GenMessage<Task> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 1);

/**
 * Recurrence is a typed generator, deliberately NOT an RFC 5545 RRULE string:
 * the repo has no RRULE writer, and validation over typed fields is far stronger
 * than over a string — which matters because this message is LLM-settable
 * through MCP create_task, i.e. a security boundary.
 *
 * @generated from message lvdr.v2.tasks.Recurrence
 */
export type Recurrence = Message<"lvdr.v2.tasks.Recurrence"> & {
  /**
   * @generated from field: lvdr.v2.tasks.RecurrenceAnchor anchor = 1;
   */
  anchor: RecurrenceAnchor;

  /**
   * @generated from field: lvdr.v2.tasks.RecurrenceFreq freq = 2;
   */
  freq: RecurrenceFreq;

  /**
   * 1..366. 366 lets "every N days" express a full leap year and nothing beyond.
   *
   * @generated from field: uint32 interval = 3;
   */
  interval: number;

  /**
   * The TARGET weekday set for WEEKLY, not an offset. 0 = Sunday .. 6 = Saturday
   * — the same numbering as Go's time.Weekday and JS getDay(), so no layer
   * renumbers. The server sorts and de-duplicates on write.
   *
   * @generated from field: repeated uint32 weekdays = 4;
   */
  weekdays: number[];

  /**
   * Target day-of-month for MONTHLY, 1..31. A value past the end of a short
   * month is CLAMPED PER PROJECTION and never written back, so 31 yields
   * Jan 31 -> Feb 28 -> Mar 31, not Mar 28.
   *
   * @generated from field: uint32 month_day = 5;
   */
  monthDay: number;

  /**
   * REQUIRED canonical IANA name, e.g. "Pacific/Auckland". A marshalled
   * timestamp carries a fixed OFFSET, not a zone, so a fixed-offset series
   * re-phases by an hour at each DST transition and a weekday target resolved
   * from the wrong zone is wrong once and then wrong forever. Go's magic
   * "Local" is REJECTED — it would anchor the series to whichever backend
   * materialised it.
   *
   * @generated from field: string timezone = 6;
   */
  timezone: string;

  /**
   * Phase anchor, interpreted IN timezone. Its clock time is preserved across
   * every projection.
   *
   * @generated from field: google.protobuf.Timestamp start = 7;
   */
  start?: Timestamp | undefined;

  /**
   * Optional end bound. Unset = no end (valid: "every Tuesday, forever").
   *
   * @generated from field: google.protobuf.Timestamp until = 8;
   */
  until?: Timestamp | undefined;

  /**
   * Optional occurrence bound; 0 = unbounded.
   *
   * @generated from field: uint32 count = 9;
   */
  count: number;
};

/**
 * Describes the message lvdr.v2.tasks.Recurrence.
 * Use `create(RecurrenceSchema)` to create a new message.
 */
export const RecurrenceSchema: GenMessage<Recurrence> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 2);

/**
 * TaskTemplate is the shape each materialised occurrence is stamped from.
 *
 * @generated from message lvdr.v2.tasks.TaskTemplate
 */
export type TaskTemplate = Message<"lvdr.v2.tasks.TaskTemplate"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string notes = 2;
   */
  notes: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 3;
   */
  priority: TaskPriority;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[];

  /**
   * @generated from field: uint32 estimate_min = 5;
   */
  estimateMin: number;

  /**
   * COS-23: copied onto every occurrence. A template has no snooze.
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel attention_level = 6;
   */
  attentionLevel: TaskAttentionLevel;
};

/**
 * Describes the message lvdr.v2.tasks.TaskTemplate.
 * Use `create(TaskTemplateSchema)` to create a new message.
 */
export const TaskTemplateSchema: GenMessage<TaskTemplate> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 3);

/**
 * @generated from message lvdr.v2.tasks.TaskSeries
 */
export type TaskSeries = Message<"lvdr.v2.tasks.TaskSeries"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * @generated from field: lvdr.v2.tasks.Recurrence rule = 2;
   */
  rule?: Recurrence | undefined;

  /**
   * @generated from field: lvdr.v2.tasks.TaskTemplate template = 3;
   */
  template?: TaskTemplate | undefined;

  /**
   * The next scheduled occurrence.
   *
   * @generated from field: google.protobuf.Timestamp next_due = 4;
   */
  nextDue?: Timestamp | undefined;

  /**
   * Unset until the first materialisation.
   *
   * @generated from field: google.protobuf.Timestamp last_spawn = 5;
   */
  lastSpawn?: Timestamp | undefined;

  /**
   * Count of materialisations; doubles as the occurrence index in the
   * idempotence key, so it is consumed in SPAWN order, not slot order.
   *
   * @generated from field: uint32 spawned = 6;
   */
  spawned: number;

  /**
   * Occurrences skipped because the user was offline. A DISPLAY count, not a
   * work queue — the materialiser emits one task, never a backlog.
   *
   * @generated from field: uint32 missed = 7;
   */
  missed: number;

  /**
   * @generated from field: bool paused = 8;
   */
  paused: boolean;

  /**
   * Why the most recent materialisation failed. A failing series is skipped,
   * never fatal to the task list.
   *
   * @generated from field: string last_error = 9;
   */
  lastError: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.TaskSeries.
 * Use `create(TaskSeriesSchema)` to create a new message.
 */
export const TaskSeriesSchema: GenMessage<TaskSeries> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 4);

/**
 * @generated from message lvdr.v2.tasks.CreateSeriesRequest
 */
export type CreateSeriesRequest = Message<"lvdr.v2.tasks.CreateSeriesRequest"> & {
  /**
   * @generated from field: lvdr.v2.tasks.TaskTemplate template = 1;
   */
  template?: TaskTemplate | undefined;

  /**
   * @generated from field: lvdr.v2.tasks.Recurrence rule = 2;
   */
  rule?: Recurrence | undefined;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.CreateSeriesRequest.
 * Use `create(CreateSeriesRequestSchema)` to create a new message.
 */
export const CreateSeriesRequestSchema: GenMessage<CreateSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 5);

/**
 * @generated from message lvdr.v2.tasks.UpdateSeriesRequest
 */
export type UpdateSeriesRequest = Message<"lvdr.v2.tasks.UpdateSeriesRequest"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskTemplate template = 2;
   */
  template?: TaskTemplate | undefined;

  /**
   * An unset `rule` leaves the schedule alone. An empty `rule.timezone` carries
   * the STORED zone forward — re-resolving on edit would silently re-phase a
   * live series whenever the user's timezone setting changed.
   *
   * @generated from field: lvdr.v2.tasks.Recurrence rule = 3;
   */
  rule?: Recurrence | undefined;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 4;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.UpdateSeriesRequest.
 * Use `create(UpdateSeriesRequestSchema)` to create a new message.
 */
export const UpdateSeriesRequestSchema: GenMessage<UpdateSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 6);

/**
 * @generated from message lvdr.v2.tasks.ListSeriesRequest
 */
export type ListSeriesRequest = Message<"lvdr.v2.tasks.ListSeriesRequest"> & {
  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.ListSeriesRequest.
 * Use `create(ListSeriesRequestSchema)` to create a new message.
 */
export const ListSeriesRequestSchema: GenMessage<ListSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 7);

/**
 * Advance the series past its next occurrence without materialising it.
 *
 * @generated from message lvdr.v2.tasks.SkipOccurrenceRequest
 */
export type SkipOccurrenceRequest = Message<"lvdr.v2.tasks.SkipOccurrenceRequest"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.SkipOccurrenceRequest.
 * Use `create(SkipOccurrenceRequestSchema)` to create a new message.
 */
export const SkipOccurrenceRequestSchema: GenMessage<SkipOccurrenceRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 8);

/**
 * @generated from message lvdr.v2.tasks.PauseSeriesRequest
 */
export type PauseSeriesRequest = Message<"lvdr.v2.tasks.PauseSeriesRequest"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * @generated from field: bool paused = 2;
   */
  paused: boolean;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.PauseSeriesRequest.
 * Use `create(PauseSeriesRequestSchema)` to create a new message.
 */
export const PauseSeriesRequestSchema: GenMessage<PauseSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 9);

/**
 * @generated from message lvdr.v2.tasks.DeleteSeriesRequest
 */
export type DeleteSeriesRequest = Message<"lvdr.v2.tasks.DeleteSeriesRequest"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.DeleteSeriesRequest.
 * Use `create(DeleteSeriesRequestSchema)` to create a new message.
 */
export const DeleteSeriesRequestSchema: GenMessage<DeleteSeriesRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 10);

/**
 * @generated from message lvdr.v2.tasks.SeriesResponse
 */
export type SeriesResponse = Message<"lvdr.v2.tasks.SeriesResponse"> & {
  /**
   * @generated from field: lvdr.v2.tasks.TaskSeries series = 1;
   */
  series?: TaskSeries | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.SeriesResponse.
 * Use `create(SeriesResponseSchema)` to create a new message.
 */
export const SeriesResponseSchema: GenMessage<SeriesResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 11);

/**
 * @generated from message lvdr.v2.tasks.SeriesListResponse
 */
export type SeriesListResponse = Message<"lvdr.v2.tasks.SeriesListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.tasks.TaskSeries series = 1;
   */
  series: TaskSeries[];
};

/**
 * Describes the message lvdr.v2.tasks.SeriesListResponse.
 * Use `create(SeriesListResponseSchema)` to create a new message.
 */
export const SeriesListResponseSchema: GenMessage<SeriesListResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 12);

/**
 * @generated from message lvdr.v2.tasks.DeleteSeriesResponse
 */
export type DeleteSeriesResponse = Message<"lvdr.v2.tasks.DeleteSeriesResponse"> & {
  /**
   * @generated from field: string series_id = 1;
   */
  seriesId: string;
};

/**
 * Describes the message lvdr.v2.tasks.DeleteSeriesResponse.
 * Use `create(DeleteSeriesResponseSchema)` to create a new message.
 */
export const DeleteSeriesResponseSchema: GenMessage<DeleteSeriesResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 13);

/**
 * @generated from message lvdr.v2.tasks.CreateTaskRequest
 */
export type CreateTaskRequest = Message<"lvdr.v2.tasks.CreateTaskRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string notes = 2;
   */
  notes: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 3;
   */
  priority: TaskPriority;

  /**
   * @generated from field: google.protobuf.Timestamp due = 4;
   */
  due?: Timestamp | undefined;

  /**
   * @generated from field: repeated string tags = 5;
   */
  tags: string[];

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 6;
   */
  workspaceId: string;

  /**
   * COS-23; UNSPECIFIED = not set
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel attention_level = 7;
   */
  attentionLevel: TaskAttentionLevel;

  /**
   * COS-23; unset = not snoozed
   *
   * @generated from field: google.protobuf.Timestamp snoozed_until = 8;
   */
  snoozedUntil?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.CreateTaskRequest.
 * Use `create(CreateTaskRequestSchema)` to create a new message.
 */
export const CreateTaskRequestSchema: GenMessage<CreateTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 14);

/**
 * @generated from message lvdr.v2.tasks.GetTaskRequest
 */
export type GetTaskRequest = Message<"lvdr.v2.tasks.GetTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.GetTaskRequest.
 * Use `create(GetTaskRequestSchema)` to create a new message.
 */
export const GetTaskRequestSchema: GenMessage<GetTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 15);

/**
 * @generated from message lvdr.v2.tasks.UpdateTaskRequest
 */
export type UpdateTaskRequest = Message<"lvdr.v2.tasks.UpdateTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskStatus status = 4;
   */
  status: TaskStatus;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 5;
   */
  priority: TaskPriority;

  /**
   * @generated from field: google.protobuf.Timestamp due = 6;
   */
  due?: Timestamp | undefined;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * An unset `due` means "leave the due date alone", so it cannot express
   * "remove the due date" — same shape trap as proto3 repeated fields not being
   * able to wire an empty collection. This flag is the explicit clear signal;
   * when true the server drops the due date and ignores `due`.
   *
   * @generated from field: bool clear_due = 8;
   */
  clearDue: boolean;

  /**
   * estimate_min: 0 = "leave unchanged" (proto3 has no presence for scalars);
   * to remove an estimate send clear_estimate = true (mirrors clear_due).
   * Scheduled block times are NOT settable here — the planner owns them.
   *
   * @generated from field: uint32 estimate_min = 9;
   */
  estimateMin: number;

  /**
   * @generated from field: bool clear_estimate = 10;
   */
  clearEstimate: boolean;

  /**
   * An empty `notes` means "leave the description alone" (proto3 scalars have no
   * presence), so it cannot express "remove the description". This is the explicit
   * clear signal; when true the server empties notes and IGNORES `notes`.
   *
   * @generated from field: bool clear_notes = 11;
   */
  clearNotes: boolean;

  /**
   * Same trap for `priority`: UNSPECIFIED (0) means "leave it alone" on THIS
   * message. When true the server unsets the priority and IGNORES `priority`.
   *
   * @generated from field: bool clear_priority = 12;
   */
  clearPriority: boolean;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 13;
   */
  workspaceId: string;

  /**
   * COS-23. UNSPECIFIED leaves the attention level unchanged.
   *
   * @generated from field: lvdr.v2.tasks.TaskAttentionLevel attention_level = 14;
   */
  attentionLevel: TaskAttentionLevel;

  /**
   * proto3 cannot tell "not sent" from UNSPECIFIED, so clearing the attention
   * level needs this flag. When true the server unsets it and IGNORES
   * `attention_level`.
   *
   * @generated from field: bool clear_attention_level = 15;
   */
  clearAttentionLevel: boolean;

  /**
   * COS-23. Unset leaves the snooze unchanged.
   *
   * @generated from field: google.protobuf.Timestamp snoozed_until = 16;
   */
  snoozedUntil?: Timestamp | undefined;

  /**
   * Unsnooze. When true the server clears the snooze and IGNORES `snoozed_until`.
   *
   * @generated from field: bool clear_snoozed_until = 17;
   */
  clearSnoozedUntil: boolean;
};

/**
 * Describes the message lvdr.v2.tasks.UpdateTaskRequest.
 * Use `create(UpdateTaskRequestSchema)` to create a new message.
 */
export const UpdateTaskRequestSchema: GenMessage<UpdateTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 16);

/**
 * @generated from message lvdr.v2.tasks.DeleteTaskRequest
 */
export type DeleteTaskRequest = Message<"lvdr.v2.tasks.DeleteTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.DeleteTaskRequest.
 * Use `create(DeleteTaskRequestSchema)` to create a new message.
 */
export const DeleteTaskRequestSchema: GenMessage<DeleteTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 17);

/**
 * @generated from message lvdr.v2.tasks.ListTasksRequest
 */
export type ListTasksRequest = Message<"lvdr.v2.tasks.ListTasksRequest"> & {
  /**
   * Unspecified = all open+in_progress. Set to filter to one status.
   *
   * @generated from field: lvdr.v2.tasks.TaskStatus status = 1;
   */
  status: TaskStatus;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.ListTasksRequest.
 * Use `create(ListTasksRequestSchema)` to create a new message.
 */
export const ListTasksRequestSchema: GenMessage<ListTasksRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 18);

/**
 * @generated from message lvdr.v2.tasks.TaskResponse
 */
export type TaskResponse = Message<"lvdr.v2.tasks.TaskResponse"> & {
  /**
   * @generated from field: lvdr.v2.tasks.Task task = 1;
   */
  task?: Task | undefined;
};

/**
 * Describes the message lvdr.v2.tasks.TaskResponse.
 * Use `create(TaskResponseSchema)` to create a new message.
 */
export const TaskResponseSchema: GenMessage<TaskResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 19);

/**
 * @generated from message lvdr.v2.tasks.TaskListResponse
 */
export type TaskListResponse = Message<"lvdr.v2.tasks.TaskListResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.tasks.Task tasks = 1;
   */
  tasks: Task[];
};

/**
 * Describes the message lvdr.v2.tasks.TaskListResponse.
 * Use `create(TaskListResponseSchema)` to create a new message.
 */
export const TaskListResponseSchema: GenMessage<TaskListResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 20);

/**
 * @generated from message lvdr.v2.tasks.DeleteTaskResponse
 */
export type DeleteTaskResponse = Message<"lvdr.v2.tasks.DeleteTaskResponse"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;
};

/**
 * Describes the message lvdr.v2.tasks.DeleteTaskResponse.
 * Use `create(DeleteTaskResponseSchema)` to create a new message.
 */
export const DeleteTaskResponseSchema: GenMessage<DeleteTaskResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 21);

/**
 * Tags + links are mutated via dedicated single-item ops (not UpdateTaskRequest):
 * proto3 repeated fields can't express "clear to empty" over the wire, so a
 * replace-all update path cannot remove a task's last tag/link. Each op replies
 * with the full TaskResponse. (Phase 0b — task tags + cross-item links.)
 *
 * @generated from message lvdr.v2.tasks.AddTaskTagRequest
 */
export type AddTaskTagRequest = Message<"lvdr.v2.tasks.AddTaskTagRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string tag = 2;
   */
  tag: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.AddTaskTagRequest.
 * Use `create(AddTaskTagRequestSchema)` to create a new message.
 */
export const AddTaskTagRequestSchema: GenMessage<AddTaskTagRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 22);

/**
 * @generated from message lvdr.v2.tasks.RemoveTaskTagRequest
 */
export type RemoveTaskTagRequest = Message<"lvdr.v2.tasks.RemoveTaskTagRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string tag = 2;
   */
  tag: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.RemoveTaskTagRequest.
 * Use `create(RemoveTaskTagRequestSchema)` to create a new message.
 */
export const RemoveTaskTagRequestSchema: GenMessage<RemoveTaskTagRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 23);

/**
 * @generated from message lvdr.v2.tasks.LinkTaskRequest
 */
export type LinkTaskRequest = Message<"lvdr.v2.tasks.LinkTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskLink link = 2;
   */
  link?: TaskLink | undefined;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.LinkTaskRequest.
 * Use `create(LinkTaskRequestSchema)` to create a new message.
 */
export const LinkTaskRequestSchema: GenMessage<LinkTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 24);

/**
 * @generated from message lvdr.v2.tasks.UnlinkTaskRequest
 */
export type UnlinkTaskRequest = Message<"lvdr.v2.tasks.UnlinkTaskRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 4;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.UnlinkTaskRequest.
 * Use `create(UnlinkTaskRequestSchema)` to create a new message.
 */
export const UnlinkTaskRequestSchema: GenMessage<UnlinkTaskRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 25);

/**
 * TASKS-08 — "which tasks came from this note".
 *
 * Resolved by a SCAN (tasks.Service.TasksByLink), deliberately NOT a secondary
 * index: note.Service.NotesByTarget answers the mirror-image question the same
 * way, and an index would owe cleanup on every task-removal path. See
 * docs/plans/2026-08-17-notes-to-tasks-design.md.
 *
 * @generated from message lvdr.v2.tasks.ListTasksByLinkRequest
 */
export type ListTasksByLinkRequest = Message<"lvdr.v2.tasks.ListTasksByLinkRequest"> & {
  /**
   * link kind (any stored kind; writable kinds are tasks.linkKindsAllowed)
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * the link target's opaque id
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * AON-06: empty => Private; set => the caller's own always-on space.
   *
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.tasks.ListTasksByLinkRequest.
 * Use `create(ListTasksByLinkRequestSchema)` to create a new message.
 */
export const ListTasksByLinkRequestSchema: GenMessage<ListTasksByLinkRequest> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 26);

/**
 * TaskRef is the lightweight projection the panel renders — id + the three
 * fields a chip shows. Deliberately NOT a full Task: the panel lists clickable
 * references and must not ship task bodies. Mirrors notepb.NoteRef.
 *
 * status/priority are the EXISTING enums, not strings, so the FE reads one
 * vocabulary for these values rather than two.
 *
 * @generated from message lvdr.v2.tasks.TaskRef
 */
export type TaskRef = Message<"lvdr.v2.tasks.TaskRef"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: lvdr.v2.tasks.TaskStatus status = 3;
   */
  status: TaskStatus;

  /**
   * @generated from field: lvdr.v2.tasks.TaskPriority priority = 4;
   */
  priority: TaskPriority;
};

/**
 * Describes the message lvdr.v2.tasks.TaskRef.
 * Use `create(TaskRefSchema)` to create a new message.
 */
export const TaskRefSchema: GenMessage<TaskRef> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 27);

/**
 * @generated from message lvdr.v2.tasks.ListTasksByLinkResponse
 */
export type ListTasksByLinkResponse = Message<"lvdr.v2.tasks.ListTasksByLinkResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.tasks.TaskRef tasks = 1;
   */
  tasks: TaskRef[];
};

/**
 * Describes the message lvdr.v2.tasks.ListTasksByLinkResponse.
 * Use `create(ListTasksByLinkResponseSchema)` to create a new message.
 */
export const ListTasksByLinkResponseSchema: GenMessage<ListTasksByLinkResponse> = /*@__PURE__*/
  messageDesc(file_tasks_tasks, 28);

/**
 * Task priority P1 (highest) .. P4 (lowest).
 *
 * UNSPECIFIED (0) is DIRECTION- AND MESSAGE-DEPENDENT, deliberately:
 *   - CreateTaskRequest — "caller didn't say" => the server defaults to P3.
 *   - UpdateTaskRequest — "leave the priority alone"; to unset it send
 *                         clear_priority = true.
 *   - task RESPONSES    — "this task has no priority": a real stored state since
 *                         TASKS-18, which sorts and groups LAST.
 * It stopped meaning "P3 default" on responses the moment clear_priority existed.
 * Do not "simplify" this back: internal/tasks.priorityFromProto's P3 default arm
 * is the create contract and must stay, while priorityToProto's default arm is
 * UNSPECIFIED. The asymmetry IS the contract.
 *
 * @generated from enum lvdr.v2.tasks.TaskPriority
 */
export enum TaskPriority {
  /**
   * @generated from enum value: TASK_PRIORITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_PRIORITY_P1 = 1;
   */
  P1 = 1,

  /**
   * @generated from enum value: TASK_PRIORITY_P2 = 2;
   */
  P2 = 2,

  /**
   * @generated from enum value: TASK_PRIORITY_P3 = 3;
   */
  P3 = 3,

  /**
   * @generated from enum value: TASK_PRIORITY_P4 = 4;
   */
  P4 = 4,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskPriority.
 */
export const TaskPrioritySchema: GenEnum<TaskPriority> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 0);

/**
 * @generated from enum lvdr.v2.tasks.TaskStatus
 */
export enum TaskStatus {
  /**
   * @generated from enum value: TASK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_STATUS_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: TASK_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: TASK_STATUS_DONE = 3;
   */
  DONE = 3,

  /**
   * @generated from enum value: TASK_STATUS_DROPPED = 4;
   */
  DROPPED = 4,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskStatus.
 */
export const TaskStatusSchema: GenEnum<TaskStatus> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 1);

/**
 * Provenance of a task. v1 is manual; later COS phases add email/sweep/research.
 *
 * @generated from enum lvdr.v2.tasks.TaskSource
 */
export enum TaskSource {
  /**
   * @generated from enum value: TASK_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_SOURCE_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * @generated from enum value: TASK_SOURCE_EMAIL = 2;
   */
  EMAIL = 2,

  /**
   * @generated from enum value: TASK_SOURCE_SWEEP = 3;
   */
  SWEEP = 3,

  /**
   * @generated from enum value: TASK_SOURCE_RESEARCH = 4;
   */
  RESEARCH = 4,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskSource.
 */
export const TaskSourceSchema: GenEnum<TaskSource> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 2);

/**
 * COS-23. UNSPECIFIED = not set. It is a fourth state, never read as LIGHT.
 *
 * @generated from enum lvdr.v2.tasks.TaskAttentionLevel
 */
export enum TaskAttentionLevel {
  /**
   * @generated from enum value: TASK_ATTENTION_LEVEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TASK_ATTENTION_LEVEL_DEEP = 1;
   */
  DEEP = 1,

  /**
   * @generated from enum value: TASK_ATTENTION_LEVEL_LIGHT = 2;
   */
  LIGHT = 2,

  /**
   * @generated from enum value: TASK_ATTENTION_LEVEL_QUICK = 3;
   */
  QUICK = 3,
}

/**
 * Describes the enum lvdr.v2.tasks.TaskAttentionLevel.
 */
export const TaskAttentionLevelSchema: GenEnum<TaskAttentionLevel> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 3);

/**
 * RecurrenceAnchor decides what the NEXT occurrence is measured from.
 *
 * @generated from enum lvdr.v2.tasks.RecurrenceAnchor
 */
export enum RecurrenceAnchor {
  /**
   * @generated from enum value: RECURRENCE_ANCHOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Keep the schedule regardless of completion: "the 1st of every month" is the
   * 1st whether or not last month's task was done.
   *
   * @generated from enum value: RECURRENCE_ANCHOR_FIXED = 1;
   */
  FIXED = 1,

  /**
   * Measure from when the task was actually completed: "water the plants 3 days
   * after I last watered them". Such a series has AT MOST ONE open occurrence —
   * the materialiser suppresses while the previous one is still open.
   *
   * @generated from enum value: RECURRENCE_ANCHOR_COMPLETION = 2;
   */
  COMPLETION = 2,
}

/**
 * Describes the enum lvdr.v2.tasks.RecurrenceAnchor.
 */
export const RecurrenceAnchorSchema: GenEnum<RecurrenceAnchor> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 4);

/**
 * @generated from enum lvdr.v2.tasks.RecurrenceFreq
 */
export enum RecurrenceFreq {
  /**
   * @generated from enum value: RECURRENCE_FREQ_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RECURRENCE_FREQ_DAILY = 1;
   */
  DAILY = 1,

  /**
   * @generated from enum value: RECURRENCE_FREQ_WEEKLY = 2;
   */
  WEEKLY = 2,

  /**
   * @generated from enum value: RECURRENCE_FREQ_MONTHLY = 3;
   */
  MONTHLY = 3,

  /**
   * @generated from enum value: RECURRENCE_FREQ_YEARLY = 4;
   */
  YEARLY = 4,
}

/**
 * Describes the enum lvdr.v2.tasks.RecurrenceFreq.
 */
export const RecurrenceFreqSchema: GenEnum<RecurrenceFreq> = /*@__PURE__*/
  enumDesc(file_tasks_tasks, 5);

